import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Listing detail opens at document bottom on mobile because scroll position
 * was preserved from /world or /search. Reset window scroll when entering detail.
 */
function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        if (!pathname.startsWith('/detail-listing')) return;

        const scrollNow = () => {
            window.scrollTo(0, 0);
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        };

        scrollNow();
        const t = window.setTimeout(scrollNow, 0);
        const r = window.requestAnimationFrame(scrollNow);
        return () => {
            window.clearTimeout(t);
            window.cancelAnimationFrame(r);
        };
    }, [pathname]);

    return null;
}

export default ScrollToTop;
